import React from "react";
import "../styles/Footer.scss";

const FooterComponent = () => {
  return (
    <footer className="footer">
      <div className="footer-section">
        <p className="footer-title">FOLLOW US</p>
        <div className="social-icons">
          <a href="https://www.behance.net/the_a__studio" target="_blank" rel="noopener noreferrer">
            <i className="fab fa-behance"></i>
          </a>
          <a href="https://www.linkedin.com/company/the-a-studio-art" target="_blank" rel="noopener noreferrer">
            <i className="fab fa-linkedin"></i>
          </a>
          <a href="https://www.instagram.com/the_a__studio" target="_blank" rel="noopener noreferrer">
            <i className="fab fa-instagram"></i>
          </a>
        </div>
      </div>
      <div className="footer-section">
        <p className="footer-contact">
          <span className="lets-talk">LET'S TALK</span>
          <a href="mailto:hey@a-studio.art">hey@a-studio.art</a>
        </p>
      </div>
    </footer>
  );
};

export default FooterComponent;
